import { useQuery } from "@tanstack/react-query";
import { fetchLocalization } from "features/localization/fetchLocalization";
import { useEffect } from "react";
import { useCatalogsStore } from "stores/catalogs";
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem, setLocalStorageItem } from "utils/localStorage";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { useLocalizationStore } from "stores/localization";

export const useLocalizationData = (lang: string) => {
  const setLocalization = useCatalogsStore((s) => s.setLocalization);
  const navigate = useNavigate();

  const { data, isSuccess, isError } = useQuery({
    queryKey: ["localization", lang],
    queryFn: () => fetchLocalization(lang),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    const rollback = () => {
      const prev = getLocalStorageItem("lang_prev") || "en";
      useLocalizationStore.getState().changeLanguage(prev);
      setLocalStorageItem(STORAGE_LANGUAGE_NAME, prev);
      navigate("/pages/service_error/", { replace: true });
    };

    if (isError) {
      rollback();
      return;
    }

    if (isSuccess && data) {
      const isEmptyObject =
        !Array.isArray(data) &&
        typeof data === "object" &&
        data !== null &&
        Object.keys(data as Record<string, unknown>).length === 0;

      const isEmptyArray = Array.isArray(data) && data.length === 0;

      if (isEmptyObject || isEmptyArray) {
        rollback();
        return;
      }

      setLocalization(data);
    }
  }, [isSuccess, isError, data, navigate, setLocalization]);
};
